// extracted by mini-css-extract-plugin
module.exports = {"container":"e_0o","tabList":"e_1o"};